module.exports = __webpack_public_path__ + "c6c931f6ebd263970d21ce58eeffa4b9.svg";